module.exports = __webpack_public_path__ + "media/Invite2edit-CreateTeam2.e208c6f5.mp4";